define.alias("shared/components/shared/ui/group-item", "settings/components/shared/ui/group-item");